import Config from './messages';

/**
 * Intercept resources that attempt to load data before a filter value is available
 *
 * @param resource
 * @param type
 * @param params
 *
 * @return boolean
 */
export const interceptLoadData = (type, resource, params) => {
    // Do not load data for non-Sysop users
    const sysOp = localStorage.getItem('sys_op');
    if (sysOp === 'false') {
        return true;
    }
    //
    return false;
};

/**
 * Create a payload object for upsert functions
 *
 * @param resource
 * @return {{payload: {}}}
 */
export const createPayload = (resource) => {
    // Create payload object
    let payloadObj = {
        "payload": {}
    };

    payloadObj.client = {
        device: Config.fuse.client.device,
        version: Config.fuse.admin.version
    };
    payloadObj.payload = {};

    return payloadObj;
};

/**
 * Customize a payload object for upsert functions
 *
 * @param type
 * @param resource
 * @param dataObj
 */
export const assignPayload = (type, resource, dataObj) => {
    let payload = {};

    // All resources populate the payload
    payload = dataObj;

    return payload;
};


// WEBPACK FOOTER //
// ./src/Fuse/restClientPreProcess.js